import { useNavigate } from 'react-router-dom';

/* ── Icons (36×36, Feather-style) ───────────────── */
function IconActivitiesReport() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="10" y1="6" x2="21" y2="6" />
      <line x1="10" y1="12" x2="21" y2="12" />
      <line x1="10" y1="18" x2="21" y2="18" />
      <polyline points="3 6 4 7 6 5" />
      <polyline points="3 12 4 13 6 11" />
      <polyline points="3 18 4 19 6 17" />
    </svg>
  );
}

function IconWeeklyReport() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
      <path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01" />
    </svg>
  );
}

function IconBillingReport() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="12" y1="1" x2="12" y2="23" />
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
    </svg>
  );
}

/** Visibles para Gerente y Líder; se muestran en el primer render sin esperar el rol. */
const SHARED_REPORT_CARDS = [
  {
    key: 'activities',
    label: 'Reporte de Actividades',
    icon: <IconActivitiesReport />,
    path: '/reports/activities',
  },
  {
    key: 'weekly',
    label: 'Reporte Semanal',
    icon: <IconWeeklyReport />,
    path: '/reports/weekly',
  },
];

const BILLING_REPORT_CARD = {
  key: 'billing',
  label: 'Reporte de Facturación',
  icon: <IconBillingReport />,
};

function ReportPicker({ role, onSelect }) {
  const navigate = useNavigate();

  function handleClick(card) {
    if (!card.path) return; /* RF-010 / RF-011 — UI pendiente */
    onSelect(card.key);
    navigate(card.path, { replace: true });
  }

  const cards =
    role === 'Gerente'
      ? [...SHARED_REPORT_CARDS, BILLING_REPORT_CARD]
      : SHARED_REPORT_CARDS;

  return (
    <div className="cat-picker">
      <h1 className="cat-picker-title">¿Qué reporte deseas generar?</h1>
      <p className="cat-picker-sub">
        Selecciona un tipo de reporte para generarlo
      </p>
      <div className="cat-picker-grid">
        {cards.map((card, i) => (
          <button
            key={card.key}
            type="button"
            className="cat-picker-card"
            style={{ '--delay': `${i * 70}ms` }}
            onClick={() => handleClick(card)}
          >
            <span className="cat-picker-icon">{card.icon}</span>
            <span className="cat-picker-label">{card.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default ReportPicker;
